import { HintType } from '@hb/domain';
import { ButtonKey, QuestionKey } from '@hb/modules/global/global.constants';
import { AnalyticsClickDirective } from '@hb/directives';
import { AdditionalInfoComponent } from '@hb/modules';
import { CalculationDetailsFieldComponent } from '@hb/modules/main/calculation-details/calculation-details-field/calculation-details-field.component';

import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

import {
    AssetDetail,
    ClosingCostDetail,
    MortgageCalculationResponse,
    PurchaseCostDetail,
    RequiredAssetDetail,
    SellingCostDetail
} from '@ap/ap-interface-apix-hypotheken-berekening';
import { currencyFormatter } from '@ap/formatters';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApContentModule } from '@ap/content';
import { ApErrorModule } from '@ap/error';
import { ApNotificationComponent } from '@ap/notification';
import '@asn/accordion';

@Component({
    selector: 'calculation-details',
    templateUrl: './calculation-details.component.html',
    standalone: true,
    imports: [
        ApAnalyticsModule,
        ApContentModule,
        ApErrorModule,
        AnalyticsClickDirective,
        ApNotificationComponent,
        AdditionalInfoComponent,
        CalculationDetailsFieldComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CalculationDetailsComponent {
    protected readonly hintType = HintType;
    protected readonly questionKey = QuestionKey;
    protected readonly buttonKey = ButtonKey;
    _mortgageCalculation: MortgageCalculationResponse;
    closingCostDetails: ClosingCostDetail;
    sellingCostDetails: SellingCostDetail;
    purchaseCostDetails: PurchaseCostDetail;
    requiredAssetsDetails: RequiredAssetDetail;
    assetsDetails: AssetDetail;

    @Input() set mortgageCalculation(mortgageCalculation: MortgageCalculationResponse) {
        this._mortgageCalculation = mortgageCalculation;

        if (mortgageCalculation?.mortgage?.asset) {
            this.closingCostDetails = this._mortgageCalculation.closing_cost?.detail;
            this.sellingCostDetails = this._mortgageCalculation.selling_cost?.detail;
            this.purchaseCostDetails = this._mortgageCalculation.purchase_cost?.detail;
            this.requiredAssetsDetails = this._mortgageCalculation.required_asset?.detail;
            this.assetsDetails = this._mortgageCalculation.asset?.detail;
        }
    }

    getTotalAssetLabel(): string {
        return this._mortgageCalculation.asset.amount.amount > 0
            ? 'main.calculation-details.assets-surplus'
            : 'main.calculation-details.assets-deficiency';
    }

    getMortgageDeficiencyInfo(): { [key: string]: string } {
        return {
            maxMortgageByProperty: currencyFormatter.formatDisplay(
                this._mortgageCalculation.mortgage.max_mortgage_by_property.amount.amount.toString(),
                0
            ),
            maxMortgageByIncome: currencyFormatter.formatDisplay(
                this._mortgageCalculation.mortgage.max_mortgage_by_income.amount.amount.toString(),
                0
            ),
            deficiencyMortgage: currencyFormatter.formatDisplay(
                Math.abs(this._mortgageCalculation.required_asset.detail.deficiency_mortgage.amount).toString(),
                0
            )
        };
    }

    getAbsTotalAsset(): number {
        return Math.abs(this._mortgageCalculation?.asset?.amount?.amount);
    }
}
